// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<TOKEN.Auth>('/auth/login', {
    method: 'POST',
    data: body,
    ...(options || { skipErrorHandler: true }),
  });
}

export async function refreshToken(body: API.RefreshTokenParams, options?: { [key: string]: any }) {
  return request<TOKEN.Auth>('/token/refresh', {
    method: 'POST',
    data: body,
    ...(options || { skipErrorHandler: true }),
  });
}

export async function outLogin(data: API.LogoutParams, options?: { [key: string]: any }) {
  return request<Record<string, any>>('/token', {
    method: 'DELETE',
    data,
    ...(options || {}),
  });
}
